<template>
  <div>
    <Header></Header>
    <div class="wrapper">
      <div class="time-bar">
        <div class="time-inner text-left text-white">
          <p class="col-12">
            <span class="active">本页内容</span>
            <span class="condition all active" @click="showKind(0)">全部</span>
            <span class="condition y18" @click="showKind(18)">2018年</span>
            <span class="condition y16" @click="showKind(16)">2016年</span>
            <span class="condition y15" @click="showKind(15)">2015年</span>
            <span class="condition y14" @click="showKind(14)">2014年</span>
            <span class="condition y13" @click="showKind(13)">2013年</span>
          </p>
        </div>
      </div>
      <div class="top">
        <p class="col-12 top-nav text-left"><span class="index">首页</span><span>&gt;</span><span class="second">企业荣誉</span></p>
        <div class="">
          <p class="title text-left">我们的奖项和荣誉</p>
          <p class="subtitle text-left">我们非常自豪地赢得了从创新，技术到客户服务等众多领域的奖项。</p>
        </div>
      </div>
      <div class="list-award">
        <div class="each year13">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">上海金融创新成果三等奖</p>
              <p class="award-subtitle text-left">2013年由上海市人民政府颁发</p>
            </div>
            <div class="col-4"><img src="../img/award/13-01.png" alt=""></div>
          </div>
        </div>
        <div class="each year13">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">现代服务业科技创新奖</p>
              <p class="award-subtitle text-left">2013年上海市嘉定区人民政府颁发</p>
            </div>
            <div class="col-4"><img src="../img/award/13-02.png" alt=""></div>
          </div>
        </div>
        <div class="each year13">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">中国小额信贷联席会理事单位</p>
              <p class="award-subtitle text-left">2013年由中国小额信贷机构联席会授予</p>
            </div>
            <div class="col-4"><img src="../img/award/13-03.png" alt=""></div>
          </div>
        </div>
        <div class="each year13">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">中国小微金融最佳产品设计奖</p>
              <p class="award-subtitle text-left">2013年由中国小额信贷机构联席会颁发</p>
            </div>
            <div class="col-4 "><img src="../img/award/13-04.png" alt=""></div>
          </div>
        </div>
        <div class="each year14">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">现代服务业金融创新奖</p>
              <p class="award-subtitle text-left">2014年由上海市嘉定区人民政府颁发</p>
            </div>
            <div class="col-4"><img src="../img/award/14-01.png" alt=""></div>
          </div>
        </div>
        <div class="each year14">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">上海商学院就业实习基地</p>
              <p class="award-subtitle text-left">2014年由上海商学院授予</p>
            </div>
            <div class="col-4 "><img src="../img/award/14-02.png" alt=""></div>
          </div>
        </div>
        <div class="each year14">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">上海市首批小贷公司接入央行征信系统试点单位</p>
              <p class="award-subtitle text-left">2014年由人民银行上海总部、上海市金融服务办、上海小贷协会授予</p>
            </div>
            <div class="col-4"><img src="../img/award/14-03.png" alt=""></div>
          </div>
        </div>
        <div class="each year14">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">中国小额贷款公司竞争力100强</p>
              <p class="award-subtitle text-left">2014年由中国小额信贷机构联席会颁发</p>
            </div>
            <div class="col-4"><img src="../img/award/14-04.png" alt=""></div>
          </div>
        </div>
        <div class="each year14">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">中国小微金融学习考察基地</p>
              <p class="award-subtitle text-left">2014年由中国小微金融研究院授予</p>
            </div>
            <div class="col-4"><img src="../img/award/14-05.png" alt=""></div>
          </div>
        </div>
        <div class="each year14">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">2014年度优秀企业金奖</p>
              <p class="award-subtitle text-left">2014年由上海市嘉定区人民政府颁发</p>
            </div>
            <div class="col-4 "><img src="../img/award/14-06.png" alt=""></div>
          </div>
        </div>
        <div class="each year15">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">现代服务业金融创新奖</p>
              <p class="award-subtitle text-left">2015年由上海市嘉定区人民政府颁发</p>
            </div>
            <div class="col-4 "><img src="../img/award/15-01.png" alt=""></div>
          </div>
        </div>
        <div class="each year15">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">上海金融信息行业协会副会长单位</p>
              <p class="award-subtitle text-left">2015年由上海金融信息行业协会授予</p>
            </div>
            <div class="col-4 "><img src="../img/award/15-02.png" alt=""></div>
          </div>
        </div>
        <div class="each year16">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">全国优秀小额贷款公司</p>
              <p class="award-subtitle text-left">2016年由中国小额贷款公司协会颁发</p>
            </div>
            <div class="col-4 "><img src="../img/award/16-01.png" alt=""></div>
          </div>
        </div>
        <div class="each year18">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">全国优秀小额贷款公司</p>
              <p class="award-subtitle text-left">2018年中国小额贷款公司协会颁发</p>
            </div>
            <div class="col-4 "><img src="../img/award/18-01.png" alt=""></div>
          </div>
        </div>
        <div class="each year18">
          <div class="row">
            <div class="  col-8">
              <p class="award-title text-left">2018年度优秀企业金奖</p>
              <p class="award-subtitle text-left">2018年由上海嘉定国资颁发</p>
            </div>
            <div class="col-4 "><img src="../img/award/18-02.png" alt=""></div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './Header'
  import Footer from './Footer'
  import $ from 'jquery'

  export default {
    name: "Award",
    components:{Header,Footer},
    methods:{
      showKind: function(k) {
        $('.condition').removeClass('active');
        if(k === 0){
          $('.list-award .each').show();
          $('.QA .subtitle').show();
          $('.all').addClass('active');
        }else{
          $('.list-award .each').hide();
          switch (k){
            case 18:
              $('.year18').show();
              $('.y18').addClass('active');
              break;

            case 16:
              $('.year16').show();
              $('.y16').addClass('active');
              break;

            case 15:
              $('.year15').show();
              $('.y15').addClass('active');
              break;

            case 14:
              $('.year14').show();
              $('.y14').addClass('active');
              break;

            case 13:
              $('.year13').show();
              $('.y13').addClass('active');
              break;
          }
        }
      }
    }
  }
</script>

<style scoped lang="less">
  p{margin:0;}
  //pc、laptop
  @media screen and (min-width: 769px) {
    .time-inner, .top, .list-award .each .row{
      width:1300px !important;
    }
    .each{
      img{
        height:220px;
      }
    }
    .award-title {
      font-size: 32px;
    }
  }

  //phone
  @media screen and (max-width: 768px) {
    .wrapper{
      padding-top:90px;
      font-size: 26px;
    }
    .each{
      img{
        width:90%;
      }
    }
    .award-title {
      font-size: 30px;
    }
  }

  .time-bar{
    height:90px;
    background:#01A494;
    .time-inner{
      height:90px;
      line-height:90px;
      margin:0 auto;
      font-size:20px;
      padding-left:50px;
      span{
        margin-right:38px;

        &.condition{
          cursor:pointer;
        }
        &.active{
          opacity:.6;
        }
      }
    }
  }

  .top{
    margin: 60px auto 48px;
    padding-left:50px;

    .top-nav{
      /*font-size:20px;*/
      margin-bottom:48px;

      .index{
        margin-right:10px;
        color:#01A494;
      }
      .second{
        margin-left:10px;
      }
    }

    .title{
      /*color:#35383D;*/
      font-size:56px;
      margin-bottom:15px;
      font-weight:800;
    }
    .subtitle{
      color:#696D71;
    }
  }

  .list-award{
    margin-top:89px;
    margin-bottom:300px;

    .each{
      height:263px;

      &:nth-child(odd){
        background:#F7F7F7;
      }
      &:nth-child(even){
        background:#fff;
      }


      .row{
        margin:0 auto;
        padding-left:50px;
        height:100%;

        .col-4{
          align-items: center;
          display: flex;
          justify-content: center;
        }
      }
      .award-title{
        margin:72px 0 24px;
        font-weight:800;
      }
      .award-subtitle{
        color:#696D71;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Award.vue